import React from "react";
import LandingFooter from "../layout/Footer/LandingFooter";

const PrivacyPolicy = () => {
    return (
        <div
            style={{
                backgroundColor: "#FFF8F5",
                minHeight: "100vh",
                color: "#0C1D36",
            }}
        >
            <div className="container py-5">
                <h1 className="fw-bold mb-4">Privacy Policy</h1>

                {/* Section 1 */}
                <div className="mb-5">
                    <h4 className="fw-semibold mb-3">1. Introduction</h4>
                    <p style={{ color: "#6C757D" }}>
                        Welcome to <strong>IDLBAY</strong> — your trusted partner for
                        <strong> attendance management, payroll automation, and payslip
                            generation</strong>. We value your privacy and are committed to
                        protecting the personal and business information you share with us.
                    </p>
                    <p style={{ color: "#6C757D" }}>
                        This Privacy Policy explains how we collect, use, store, and protect
                        your data when you use our website, platform, and related services
                        (“<strong>Services</strong>”). By accessing or using IDLBAY, you
                        agree to the practices described below. If you do not agree, please
                        discontinue using our Services.
                    </p>
                </div>

                {/* Section 2 */}
                <div className="mb-5">
                    <h4 className="fw-semibold mb-3">2. Information We Collect</h4>
                    <p style={{ color: "#6C757D" }}>
                        To deliver a seamless experience, we collect the following types of
                        information:
                    </p>
                    <ul style={{ color: "#6C757D" }}>
                        <li>
                            <strong>Account Information:</strong> Such as your name, company
                            name, email, contact details, and login credentials.
                        </li>
                        <li>
                            <strong>Employee Data:</strong> Information you upload or enter,
                            including employee names, contact details, attendance records,
                            salary details, tax information, and other HR-related data.
                        </li>
                        <li>
                            <strong>Financial Information:</strong> Billing, subscription, and
                            payment transaction details used for account management.
                        </li>
                        <li>
                            <strong>Technical Data:</strong> Device type, browser, IP address,
                            and activity logs used to ensure security and improve performance.
                        </li>
                        <li>
                            <strong>Cookies & Usage Data:</strong> Information collected
                            through cookies or analytics tools to personalize your experience.
                        </li>
                    </ul>
                </div>

                {/* Section 3 */}
                <div className="mb-5">
                    <h4 className="fw-semibold mb-3">3. How We Use Your Information</h4>
                    <p style={{ color: "#6C757D" }}>
                        We use your information responsibly and only for legitimate business
                        purposes, such as:
                    </p>
                    <ul style={{ color: "#6C757D" }}>
                        <li>Operating and maintaining our payroll and HR platform.</li>
                        <li>Tracking employee attendance and generating payslips.</li>
                        <li>Processing salary payments and statutory deductions.</li>
                        <li>Providing customer support and resolving issues.</li>
                        <li>Sending service updates, notifications, and important alerts.</li>
                        <li>Improving our software features and user experience.</li>
                        <li>Ensuring compliance with legal and tax regulations.</li>
                    </ul>
                </div>

                {/* Section 4 */}
                <div className="mb-5">
                    <h4 className="fw-semibold mb-3">4. Data Sharing & Disclosure</h4>
                    <p style={{ color: "#6C757D" }}>
                        We do <strong>not</strong> sell, trade, or rent your personal
                        information. However, we may share limited data in the following
                        cases:
                    </p>
                    <ul style={{ color: "#6C757D" }}>
                        <li>
                            <strong>With Your Consent:</strong> When you enable integrations
                            with third-party tools like accounting or banking platforms.
                        </li>
                        <li>
                            <strong>With Service Providers:</strong> Trusted partners who help
                            us with hosting, security, analytics, and payments — all bound by
                            confidentiality and data protection agreements.
                        </li>
                        <li>
                            <strong>For Legal Reasons:</strong> When required by law,
                            regulation, or court order to disclose information.
                        </li>
                        <li>
                            <strong>Business Transfers:</strong> In case of a merger,
                            acquisition, or restructuring, your data may be securely
                            transferred as part of that transaction.
                        </li>
                    </ul>
                </div>

                {/* Section 5 */}
                <div className="mb-5">
                    <h4 className="fw-semibold mb-3">5. Data Security</h4>
                    <p style={{ color: "#6C757D" }}>
                        We take data security seriously. IDLBAY uses encryption, firewalls,
                        and secure hosting environments to protect your information from
                        unauthorized access or misuse. However, no system is completely
                        invulnerable, and we encourage users to adopt good security
                        practices, such as strong passwords and limited access permissions.
                    </p>
                </div>

                {/* Section 6 */}
                <div className="mb-5">
                    <h4 className="fw-semibold mb-3">6. Data Retention</h4>
                    <p style={{ color: "#6C757D" }}>
                        We retain your information only for as long as it is needed to
                        provide our Services, comply with legal obligations, or resolve
                        disputes. You may request deletion of your account and associated
                        data at any time by writing to{" "}
                        <a
                            href="mailto:hr@idlbay.com"
                            style={{ color: "#0C1D36", textDecoration: "underline" }}
                        >
                            hr@idlbay.com
                        </a>
                        .
                    </p>
                </div>

                {/* Section 7 */}
                <div className="mb-5">
                    <h4 className="fw-semibold mb-3">7. Your Rights</h4>
                    <p style={{ color: "#6C757D" }}>
                        We respect your rights regarding your personal information. You can:
                    </p>
                    <ul style={{ color: "#6C757D" }}>
                        <li>Access, update, or correct your personal data.</li>
                        <li>Request deletion of your data where legally permissible.</li>
                        <li>Opt out of non-essential communications.</li>
                        <li>
                            Request a copy of the information we hold about your organization.
                        </li>
                    </ul>
                    <p style={{ color: "#6C757D" }}>
                        To exercise these rights, contact us using the details provided
                        below.
                    </p>
                </div>

                {/* Section 8 */}
                <div className="mb-5">
                    <h4 className="fw-semibold mb-3">8. Cookies & Tracking Technologies</h4>
                    <p style={{ color: "#6C757D" }}>
                        IDLBAY uses cookies and similar technologies to help us understand
                        how our platform is used, improve functionality, and provide
                        personalized experiences. You can control or disable cookies through
                        your browser settings, but doing so may affect some features of the
                        Service.
                    </p>
                </div>

                {/* Section 9 */}
                <div className="mb-5">
                    <h4 className="fw-semibold mb-3">9. Third-Party Links</h4>
                    <p style={{ color: "#6C757D" }}>
                        Our website or platform may contain links to third-party websites or
                        tools. We are not responsible for the privacy practices of those
                        websites. Please review their privacy policies before sharing any
                        personal information.
                    </p>
                </div>

                {/* Section 10 */}
                <div className="mb-5">
                    <h4 className="fw-semibold mb-3">10. Policy Updates</h4>
                    <p style={{ color: "#6C757D" }}>
                        We may update this Privacy Policy periodically to reflect new laws,
                        security measures, or feature enhancements. Any updates will be
                        posted here with the latest “Last Updated” date. Continued use of
                        our Services means you accept these updates.
                    </p>
                </div>

                {/* Section 11 */}
                <div>
                    <h4 className="fw-semibold mb-3">11. Contact Us</h4>
                    <p style={{ color: "#6C757D" }}>
                        We’re always here to help. If you have any questions, concerns, or
                        data-related requests, please contact us:
                    </p>
                    <p style={{ color: "#6C757D" }}>
                        <strong>Email:</strong>{" "}
                        <a
                            href="mailto:hr@idlbay.com"
                            style={{ color: "#0C1D36", textDecoration: "underline" }}
                        >
                            hr@idlbay.com
                        </a>
                        <br />
                        <strong>Address:</strong> IDLBAY, Office No. 1, First Floor, Door
                        No. 1, B. Narasimhan 3rd Street, T-Nagar, Chennai, Tamil Nadu –
                        600017
                    </p>
                </div>
            </div>
            <LandingFooter />
        </div>
    );
};

export default PrivacyPolicy;
